var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHelperText = void 0;
var FormHelperText_1 = __importDefault(require("./FormHelperText"));
exports.FormHelperText = FormHelperText_1.default;
exports.default = FormHelperText_1.default;
//# sourceMappingURL=index.js.map